module.exports = __webpack_public_path__ + "img/abnormal.a04c9359.png";